<template lang="pug">
  v-menu(offset-y)
    template(v-slot:activator="{on}")
      v-btn(color="#2C3A47" class="white--text mr-2" v-on="on")
        v-icon mdi-earth {{ displayLocale }}

    v-list
      v-list-item(v-for="(item, i) in langs" :key="`Lang${i}`" :value="item.lang" @click="switchLocale(item.lang)" :class="[item.class]")
        v-list-item-title {{item.lang.toUpperCase()}}
</template>

<script>

import CountryFlag from 'vue-country-flag'

export default {
  data() {
    return {
      showMenu: false,
      langs: [
        {
          lang: 'en',
          flag: 'gb',
          class: 'btnEN'
        },
        {
          lang: 'pt',
          flag: 'pt',
          class: 'btnPT'
        },
        {
          lang: 'es',
          flag: 'es',
          class: 'btnES'
        },
      ]
    }
  },
  components: {
    CountryFlag
  },
  methods: {
    switchLocale(lang) {
      this.$store.dispatch('setLocale', lang)
    }
  },
  computed: {
    displayLocale() {
      return this.$i18n.locale
    }
  }
}
</script>
